<template>
  <div class="informationCompletion">
    <div class="topbar">
      <TopBar :imgsrc="logo" color="#000" />
      <p>数据资源超市个人中心</p>
    </div>
    <div class="content_box">
      <div class="content">
        <div class="form-container">
          <h2 class="form-title">完善您的账户信息</h2>

          <!-- 头像上传区域 -->
          <div class="avatar-section">
            <div class="avatar-label">头像</div>
            <div class="avatar-upload-group">
              <div class="avatar-item">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                   :http-request="UploadFile"
                  >
                  <div class="avatar-container">
                    <img :src="avatarUrl || Avatar" class="avatar">
                    <!-- <img src="https://sxdatasets.oss-cn-chengdu.aliyuncs.com/2/dataset/Snipaste_2025-06-19_17-36-51.png" class="avatar"> -->
                    <div class="avatar-overlay">
                      <img :src="camera" class="camera-icon">
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>

          <!-- 表单区域 -->
          <el-form
            :model="form"
            :rules="rules"
            ref="userForm"
            label-width="100px"
            class="user-form"
          >
            <el-form-item label="姓名" prop="name" required>
              <el-input
                v-model="form.name"
                placeholder="请输入您的姓名"
                maxlength="30"
                show-word-limit
                class="form-input"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="公司名称" prop="company" required>
              <el-input
                v-model="form.company"
                placeholder="请输入公司名称"
                maxlength="50"
                show-word-limit
                class="form-input"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱地址"
                class="form-input"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="官网" prop="website">
              <el-input
                v-model="form.website"
                placeholder="请输入官网地址"
                class="form-input"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="简介" prop="description">
              <el-input
                type="textarea"
                v-model="form.description"
                placeholder="请输入简介"
                :rows="6"
                resize="none"
                maxlength="100"
                show-word-limit
                class="form-textarea"
              >
              </el-input>
            </el-form-item>
          </el-form>

          <!-- 按钮区域 -->
          <div class="button-group">
            <el-button type="primary" @click.prevent="submitForm" class="submit-btn"
              >确认</el-button
            >
            <el-button @click="resetForm" class="cancel-btn">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {FileUpLoad } from '@/server/UpLoadFile'
import { PostUserInfo } from "@/api/user";
import logo from "@/assets1/logo_slices/编组 2(1).png";
import { Message } from "element-ui";
import TopBar from "@/views/supermarket/TopBar";
import Avatar from "@/assets1/后台/Avatar.png";
import camera from "@/assets1/后台/camera.png";
export default {
  data() {
    return {
      Avatar,
      camera,
      logo,
      form: {
        avatar: "",
        name: "",
        company: "",
        email: "",
        website: "",
        description: "",
      },
      avatarUrl:'',
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        website: [
          {
            pattern: /^https?:\/\//,
            message: "请输入正确的网址格式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    TopBar,
  },
  methods: {
    async UploadFile(options){
    console.log(options,'file');
    const res=await FileUpLoad(options.file)
    console.log(res,'res');
    this.form.avatar=res
    this.avatarUrl='https://sxdatasets.oss-cn-chengdu.aliyuncs.com/'+res
  },
    submitForm() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          console.log("提交表单:", this.form);
          const res = await PostUserInfo({
            username: this.form.name,
            company_name: this.form.company,
            avatar_bucket: "sxdatasets",
            avatar_object: this.form.avatar,
            email: this.form.email,
            website: this.form.website,
            bio: this.form.description,
          });
          Message({
            message: "修改成功",
            type: "success",
          });
          this.avatarUrl = "";
          this.$router.push('/supermarket')
          console.log(res, "res");
          // 这里可以添加提交到后端的逻辑
        } else {
          
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.userForm.resetFields();
      this.form.avatar1 = "";
      this.form.avatar2 = "";
      this.form.avatar3 = "";
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      // 这里处理上传成功的逻辑
      // 可以根据需要设置对应的头像
    },
  },
};
</script>

<style scoped>
.content_box {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #f7f8fc;
}
.content {
  margin-top: 16px;
  width: 1200px;
  height: 818px;
  border-radius: 12px;
  background-color: #fff;
  padding: 40px;
  box-sizing: border-box;
}

.form-container {
  max-width: 600px;
  margin: 0 auto;
}

.form-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: left;
}

/* 头像上传样式 */
.avatar-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.avatar-label {
  width: 100px;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: right;
  padding-right: 12px;
}

.avatar-upload-group {
  display: flex;
  gap: 20px;
}

.avatar-item {
  width: 80px;
  height: 80px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.camera-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* 表单样式 */
.user-form {
  margin-bottom: 40px;
}

.form-input {
  width: 100%;
}

.form-textarea {
  width: 100%;
}

/* 按钮样式 */
.button-group {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  margin-left: 100px;
}

.submit-btn {
  background-color: #409eff;
  border-color: #409eff;
  padding: 12px 30px;
  font-size: 14px;
  border-radius: 4px;
}

.cancel-btn {
  padding: 12px 30px;
  font-size: 14px;
  border-radius: 4px;
  color: #606266;
  border-color: #dcdfe6;
}

.informationCompletion {
  background-color: #f7f8fc;
  min-width: 1920px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.topbar {
  min-width: 1920px;
  height: 220px;
  background-image: url("../../../../assets1/已发布数据集-已选_slices/位图.png");
}
.topbar p {
  font-family: Heavy;
  line-height: 52px;
  color: black;
  font-size: 38px;
  padding-left: 492px;
  padding-top: 104px;
}

/* ElementUI 样式重写 */
.el-form-item__label {
  color: #606266;
  font-weight: normal;
}

.el-input__inner {
  border-radius: 4px;
}

.el-textarea__inner {
  border-radius: 4px;
}

/* 字数统计样式 */
.el-input__count {
  color: #909399;
}
</style>
